// extracted by mini-css-extract-plugin
export default {"wrapper":"wB-z","viewport":"xB-z","container":"yB-z","slide":"zB-z"};